import * as CONSTANTS from "../utils/constants/constants";
import axios from "./axiosInstance";

export interface DeviceMeeting {
  room: string;
  domain: string;
  token: string;
  ttl: number;
  call_context_id: string;
  intervention_id: string;
}

export async function getDeviceMeeting(
  deviceId: string,
  accessToken: string,
  signal: AbortSignal,
  interventionId?: string,
): Promise<DeviceMeeting> {
  const response = await axios.post<{ jitsi: DeviceMeeting }>(
    `${CONSTANTS.HOST}api/v1/device/${encodeURIComponent(deviceId)}/meeting/`,
    interventionId ? { intervention_id: interventionId } : {},
    {
      headers: { authorization: `Bearer ${accessToken}` },
      signal,
    },
  );
  const meeting = response.data.jitsi;
  if (
    !meeting ||
    !meeting.room ||
    !meeting.domain ||
    !meeting.call_context_id ||
    !meeting.intervention_id ||
    (interventionId && meeting.intervention_id !== interventionId) ||
    !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(meeting.token)
  ) {
    throw new Error("The backend returned an invalid meeting");
  }
  return meeting;
}
